exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-a0b5dd50] {\n  background-color: #3b8686;\n}\n.edit-fields[data-v-a0b5dd50] {\n  padding-bottom: 82px;\n}\n", ""]);

// exports
